<template>
  <div class="app-container">
    <div class="flex justify-between items-center mb-4">
      <el-form ref="queryForm"
               :model="queryParams"
               :inline="true"
               label-width="68px">
        <el-form-item label="姓名"
                      prop="name">
          <el-input v-model="queryParams.name"
                    placeholder="请输入姓名"
                    clearable
                    size="small" />
        </el-form-item>
        <el-form-item label="工号"
                      prop="phone">
          <el-input v-model="queryParams.phone"
                    placeholder="请输入工号"
                    clearable
                    size="small" />
        </el-form-item>

        <el-form-item label="部门"
                      prop="department">
          <el-input v-model="queryParams.department"
                    placeholder="请输入部门"
                    clearable
                    size="small" />
        </el-form-item>

        <el-form-item label="状态"
                      prop="status">
          <el-select v-model="queryParams.status"
                     placeholder="请选择状态"
                     clearable
                     size="small">
            <el-option label="允许" value="allowed" />
            <el-option label="拒绝" value="denied" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     :loading="loading"
                     size="mini"
                     @click="handleQuery">查询</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
      
      <!-- <el-button type="primary"
                 icon="el-icon-plus"
                 size="mini"
                 @click="handleAdd">新增用户</el-button> -->
    </div>
    
    <div class="gap"></div>
    
    <el-table v-loading="loading"
              :data="list">
      <el-table-column label="OpenID"
                       label-class-name="title"
                       align="center"
                       prop="openid"
                       show-overflow-tooltip />
      <el-table-column label="姓名"
                       label-class-name="title"
                       align="center"
                       prop="name" />
      <el-table-column label="性别"
                       label-class-name="title"
                       align="center"
                       prop="gender">
       
      </el-table-column>
      <el-table-column label="部门"
                       label-class-name="title"
                       align="center"
                       prop="department" />
      <el-table-column label="工号"
                       label-class-name="title"
                       align="center"
                       prop="phone" />
      <el-table-column label="状态"
                       label-class-name="title"
                       align="center"
                       prop="status">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-value="allowed"
            inactive-value="denied"
            active-text="允许"
            inactive-text="拒绝"
            @change="handleStatusChange(scope.row)" />
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       align="center"
                       label-class-name="title"
                       class-name="small-padding fixed-width"
                       width="180">
        <template slot-scope="scope">
          <el-button class="inspect-button"
                     size="mini"
                     type="text"
                     icon="el-icon-edit"
                     @click="handleUpdate(scope.row)">修改</el-button>
          <el-button class="inspect-button"
                     size="mini"
                     type="text"
                     icon="el-icon-delete"
                     @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <el-pagination
      v-show="total>0"
      :total="total"
      @current-change="getList"
      @prev-click='getList'
      @next-click="getList"
    />

    <!-- 用户编辑对话框 -->
    <el-dialog :title="title"
               :visible.sync="open"
               :close-on-click-modal="false"
               width="700px"
               append-to-body>
      <el-form ref="form"
               :model="form"
               :rules="rules"
               label-width="100px"
               size="mini">
        <el-row>
          <el-col :span="12">
            <el-form-item label="OpenID" prop="openid">
              <el-input v-model="form.openid"
                        :disabled="!!form.id"
                        clearable
                        size="small" placeholder="请输入OpenID" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form.name"
                        clearable
                        size="small" placeholder="请输入姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="gender">
              <el-select v-model="form.gender"
                         placeholder="请选择性别"
                         style="width: 100%"
                         size="small">
                <el-option label="男" value="1" />
                <el-option label="女" value="2" />
                <el-option label="未知" value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部门" prop="department">
              <el-input v-model="form.department"
                        clearable
                        size="small" placeholder="请输入部门" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工号" prop="phone">
              <el-input v-model="form.phone"
                        clearable
                        size="small" placeholder="请输入工号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-select v-model="form.status"
                         placeholder="请选择状态"
                         style="width: 100%"
                         size="small">
                <el-option label="允许" value="1" />
                <el-option label="拒绝" value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公司" prop="companyCode">
              <el-input v-model="userInfo.companyName"
                        disabled
                        size="small" placeholder="公司名称" />
              <el-input type="hidden" v-model="form.companyCode" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submit">确定</el-button>
        <el-button @click="open = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addUser, getUserList, updateUser, deleteUser, updateUserStatus } from '../api/user/index'

export default {
  name: 'UserManage',
  data () {
    return {
      pageIndex: 1,
      pageSize: 10,
      title: '',
      queryParams: {},
      loading: false,
      list: [],
      total: 0,
      open: false,
      userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
      form: {
        openid: '',
        name: '',
        gender: '1',
        department: '',
        phone: '',
        status: '1',
        companyCode: ''
      },
      rules: {
        openid: [
          { required: true, message: '请输入OpenID', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        gender: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        department: [
          { required: true, message: '请输入部门', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入工号', trigger: 'blur' },
          { pattern: /^\d+$/, message: '请输入正确的工号格式', trigger: 'blur' }  
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        companyCode: [
          { required: true, message: '请选择公司', trigger: 'change' }
        ]
      }
    }
  },
  created () {
        console.log(localStorage.getItem('userInfo'))
    // 获取当前登录用户信息
    this.userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
    this.form.companyCode = this.userInfo.companyCode || ''
    console.log(this.userInfo)
    this.handleQuery()
  },
  methods: {
    // 新增按钮
    handleAdd () {
      this.title = '新增用户'
      this.open = true
      this.form = {
        openid: '',
        name: '',
        gender: '1',
        department: '',
        phone: '',
        status: '1',
        companyCode: this.userInfo.companyCode || ''
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    
    // 确定按钮
    submit () {
      if (!this.userInfo.companyCode) {
        this.$message.error('请先登录并确保所属公司信息完整')
        return
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 确保companyCode始终为当前用户的公司ID
          this.form.companyCode = this.userInfo.companyCode
          if (!this.form.id) {
            // 新增用户
            addUser(this.form).then(res => {
              if (res.code == '200') {
                this.$message.success('新增成功')
                this.open = false
                this.handleQuery()
              } else {
                this.$message.error(res.message || '服务异常')
              }
            })
          } else {
            // 修改用户
            updateUser(this.form).then(res => {
              if (res.code == '200') {
                this.$message.success('修改成功')
                this.open = false
                this.handleQuery()
              } else {
                this.$message.error(res.message || '服务异常')
              }
            })
          }
        } else {
          return false
        }
      })
    },
    
    // 修改按钮
    handleUpdate (row) {
      this.title = '修改用户'
      this.open = true
      this.form = Object.assign({}, row)
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    
    // 状态变更
    handleStatusChange (row) {
      if (!this.userInfo.companyCode) {
        this.$message.error('请先登录并确保所属公司信息完整')
        // 恢复原状态
        row.status = row.status === '1' ? '0' : '1'
        return
      }
      const statusText = row.status === '1' ? '允许' : '拒绝'
      this.$confirm(`确定要将用户状态设置为"${statusText}"吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateUserStatus({ id: row.id, status: row.status, companyCode: this.userInfo.companyCode }).then(res => {
          if (res.code == '200') {
            this.$message.success('状态修改成功')
          } else {
            this.$message.error(res.message || '状态修改失败')
            // 恢复原状态
            row.status = row.status === '1' ? '0' : '1'
          }
        }).catch(() => {
          // 恢复原状态
          row.status = row.status === '1' ? '0' : '1'
        })
      }).catch(() => {
        // 恢复原状态
        row.status = row.status === '1' ? '0' : '1'
      })
    },
    
    // 查询按钮
    handleQuery () {
      debugger
      if (!this.userInfo.companyCode) {
        this.$message.error('请先登录并确保所属公司信息完整')
        return
      }
      let data = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        companyCode: this.userInfo.companyCode,
        ...this.queryParams
      }
      this.loading = true
      getUserList(data).then(res => {
        this.loading = false
        if (res.code == '200') {
          this.list = res.data
          this.total = res.total
        } else {
          this.$message.error('获取数据失败')
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('网络错误')
      })
    },
    
    // 删除按钮
    handleDelete (id) {
      if (!this.userInfo.companyCode) {
        this.$message.error('请先登录并确保所属公司信息完整')
        return
      }
      this.$confirm('确定要删除此用户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let obj = { id: id, companyCode: this.userInfo.companyCode }
        deleteUser(obj).then(res => {
          if (res.code == '200') {
            this.$message.success('删除成功')
            this.handleQuery()
          } else {
            this.$message.error('删除失败')
          }
        })
      }).catch(() => {
        // 取消删除
      })
    },
    
    // 重置查询
    resetQuery () {
      this.queryParams = {}
      this.handleQuery()
    },
    
    // 获取列表
    getList (e) {
      this.pageIndex = e
      this.handleQuery()
    }
  }
}
</script>

<style scoped>
.gap {
  margin: 30px 10px;
}

.title {
  color: black;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.items-center {
  align-items: center;
}

.mb-4 {
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/userManage/index.vue